import AuthModal from '@/components/SupervisorUniqueKey/Modal'
import { mapState, mapActions, mapGetters } from 'vuex'
import PosDailyCash from '../../models/POS/PosDailyCash'
import DateField from '../../components/reusable_components/next/Fields/DateField'
import { cloneDeep } from 'lodash'
import IntegerInput from '../../components/reusable_components/Input/IntegerInput'
import axios from 'axios'
import { getIntegrationTicketNumber } from '@/services/API/Integration'
import PosCashMovement from '../../models/POS/PosCashMovement'
import CurrencyUtils from '../../mixins/reusable_mixins/CurrencyUtils'
import SlSaleTicket from '../../models/Sale/SlSaleTicket'
import SlSaleInvoice from '../../models/Sale/SlSaleInvoice'
import SlSaleCreditNote from '../../models/Sale/SlSaleCreditNote'
import PosCustomerReceivablePayment from '../../models/POS/PosCustomerReceivablePayment'

const initialState = () => ({
    loading: false,
    newRendition: true,
    loading: false,
    openingData: null,
    date: '',
    authorized: false,
    minorSales: 0,
    minorSalesNumber: 0,
    minorSalesModal: false,
    minorSalesReady: false,
    calcData: null,
    step: 1,
    billCounter: {},
    quadrature: {},
    authUserId: null,
    observation: '',

    loadingMovements: false,
    movementDetails: [],
    movementDetailHeaders: [
        {
            text: '#',
            value: 'id',
        },
        {
            text: 'Tipo',
            value: 'type',
        },
        {
            text: 'Motivo',
            value: 'movementType',
        },
        {
            text: 'Fecha',
            value: 'date',
        },
        {
            text: 'Hora',
            value: 'time',
        },
        {
            text: 'Monto',
            value: 'amount',
        },
    ],
    reportData: [],
    reportFilter: '',
    ticketHeaders: [
        { text: 'FOLIO', value: 'folio' },
        { text: 'VENDEDOR', value: 'vendedor' },
        { text: 'CAJERO', value: 'cajero' },
        { text: 'TOTAL', value: 'total', show: 'showTotal' },
        { text: 'PAGOS', value: 'payments', show: 'showPayments' },
    ],
    allCreditNotesHeaders: [
        { text: 'FOLIO', value: 'folio' },
        { text: 'SUPERVISOR', value: 'supervisor' },
        { text: 'CAJERO', value: 'cajero' },
        { text: 'CLIENTE', value: 'cliente' },
        { text: 'TOTAL', value: 'total', show: 'total' },
    ],
    allTicketHeaders: [
        { text: 'TIPO', value: 'tipo' },
        { text: 'FOLIO', value: 'folio' },
        { text: 'VENDEDOR', value: 'vendedor' },
        { text: 'CAJERO', value: 'cajero' },
        { text: 'EMPLEADO COMPRADOR', value: 'razon_social_cliente' },
        { text: 'TOTAL', value: 'total', show: 'showTotal' },
        { text: 'PAGOS', value: 'payments', show: 'showPayments' },
    ],
    employeeSaleHeaders: [
        { text: 'FOLIO', value: 'folio' },
        { text: 'VENDEDOR', value: 'vendedor' },
        { text: 'CAJERO', value: 'cajero' },
        { text: 'EMPLEADO COMPRADOR', value: 'razon_social_cliente' },
        { text: 'TOTAL', value: 'total', show: 'showTotal' },
        { text: 'PAGOS', value: 'payments', show: 'showPayments' },
    ],
    invoiceHeaders: [
        { text: 'FOLIO', value: 'folio' },
        { text: 'VENDEDOR', value: 'vendedor' },
        { text: 'CAJERO', value: 'cajero' },
        { text: 'RUT CLIENTE', value: 'razon_social_cliente' },
        { text: 'R. SOCIAL CLIENTE', value: 'razon_social_cliente' },
        { text: 'NETO', value: 'neto', show: 'showNeto' },
        { text: 'IVA', value: 'iva', show: 'showIva' },
        { text: 'TOTAL', value: 'total', show: 'showTotal' },
        { text: 'PAGOS', value: 'payments', show: 'showPayments' },
    ],
    activeReport: 0,
    showReportModal: false,

    activeDocument: null,
    showDocumentModal: false,

    detailHeaders: [
        { text: '#', value: 'id', sortable: false },
        { text: 'PROD', value: 'id', sortable: false },
        { text: 'CANT', value: 'id', sortable: false },
        { text: 'PREC', value: 'id', sortable: false },
        { text: 'DCTO', value: 'id', sortable: false },
        { text: 'SUBT', value: 'id', sortable: false },
    ],

    ticketsToShow: 1,

    allCreditNoteReport: {
        items: [],
    },
    payments: {
        headers: [],
        items: [],
    },
})

export default {
    name: 'rendicion-view',
    components: { AuthModal, DateField, IntegerInput },
    mixins: [CurrencyUtils],
    data: () => initialState(),
    computed: {
        ...mapState('AuthModule', {
            cashDeskID: state => state.cash_desk_id,
            cashDeskToken: state => state.cash_desk_token,
            TBK: state => state.tbk,
        }),
        ...mapState('SnackbarModalModule', ['responseConfirm']),
        ...mapState('UniqueKeyModule', ['uniqueKey']),
        ...mapGetters('AuthModule', ['branchOfficeName', 'branchOfficeID']),
        showRendition() {
            //return true
            return this.authorized && this.minorSalesReady
        },
        openingUser() {
            if (!this.openingData) return ''
            return this.openingData.g_user_opening_cashier.hr_employee.name_case
        },
        openingDate() {
            if (!this.openingData) return ''
            return this.openingData.created_at
                .split(' ')[0]
                .split('-')
                .reverse()
                .join('-')
        },
        openingTime() {
            if (!this.openingData) return ''
            return this.openingData.created_at.split(' ')[1]
        },
        openingAmount() {
            if (!this.openingData) return ''
            return parseInt(this.openingData.initial_amount_cash)
        },
        realCashTotal() {
            if (!this.billCounter || !Object.keys(this.billCounter).length)
                return 0
            return Object.keys(this.billCounter).reduce((tot, key) => {
                tot += this.billCounter[key].amount
                return tot
            }, 0)
        },
        totalDiff() {
            if (!this.quadrature || !Object.keys(this.quadrature).length)
                return 0
            return Object.keys(this.quadrature).reduce((tot, key) => {
                tot += this.quadrature[key].diff_amount
                return tot
            }, 0)
        },
        saleDetails() {
            if (!this.calcData || !this.calcData.summary) return
            let summary = cloneDeep(this.calcData.summary)
            let format = {
                cash: { name: 'Efectivo' },
                rounding_law: { name: 'Ley de Redondeo' },
                transbank_debit: { name: 'Débito' },
                transbank_credit: { name: 'Crédito' },
                check_to_day: { name: 'Cheque al Día' },
                check_to_date: { name: 'Cheque a Fecha' },
                customer_credit: { name: 'Crédito Cliente' },
                credit_note: { name: 'Notas de Crédito' },
                electronic_transfer: { name: 'Transferencia Electrónica' },
                bank_document: { name: 'Documento Bancario' },
                cash_employee: {
                    name: 'Efectivo Venta Empleado',
                    isEmployee: true,
                },
                rounding_law_employee: {
                    name: 'Ley de Redondeo Empleado',
                    isEmployee: true,
                },
                payroll_discount: {
                    name: 'Descuento por Planilla',
                    isEmployee: true,
                },
                totals: { name: 'Total' },
            }
            Object.keys(format).forEach(key => {
                summary[key] = Object.assign(summary[key], format[key])
            })
            return summary
        },
        saleMovements() {
            if (!this.calcData || !this.calcData.movements) return []
            let movements = cloneDeep(this.calcData.movements)
            let format = {
                ingress_total: { name: 'Total Ingresos', sum: true },
                expenses: { name: 'Gastos' },
                retirement: { name: 'Retiros' },
                other_egress: { name: 'Otros Egresos' },
            }
            Object.keys(format).forEach(key => {
                movements[key] = Object.assign(movements[key], format[key])
            })
            return movements
        },
        saleMovementTotal() {
            if (!this.saleMovements) return 0
            return (
                this.saleMovements.ingress_total.amount -
                this.saleMovements.expenses.amount -
                this.saleMovements.retirement.amount -
                this.saleMovements.other_egress.amount
            )
        },
        reportTitle() {
            return `Reporte de ${
                this.activeReport === 0
                    ? 'Boletas'
                    : this.activeReport === 1
                    ? 'Facturas'
                    : this.activeReport === 2
                    ? 'Notas de Crédito'
                    : this.activeReport === 3
                    ? 'Todas las Notas de Crédito'
                    : 'Pagos Cliente'
            }`
        },
        showedReport() {
            if (this.activeReport === 0) {
                if (this.ticketsToShow === 1)
                    return {
                        items: [
                            ...this.ticketReport.items,
                            ...this.employeeSaleReport.items,
                        ],
                        headers: this.allTicketHeaders,
                    }
                if (this.ticketsToShow === 2) return this.ticketReport
                if (this.ticketsToShow === 3) return this.employeeSaleReport
            }
            if (this.activeReport === 1) return this.invoiceReport
            if (this.activeReport === 2) return this.creditNoteReport
            if (this.activeReport === 3) return this.allCreditNoteReport
            if (this.activeReport === 4) return this.payments
        },
        filteredReport() {
            return this.reportFilter && this.activeReport !== 4
                ? this.showedReport.items.filter(item =>
                      [
                          item.folio,
                          item.vendedor,
                          item.cajero,
                          item.total,
                          item.payments,
                      ]
                          .map(i => ('' + i).toLowerCase())
                          .some(i =>
                              i.includes(this.reportFilter.toLowerCase())
                          )
                  )
                : this.showedReport.items
        },
        ticketReport() {
            return this.getSaleReport('BOLETA', this.ticketHeaders)
        },
        invoiceReport() {
            return this.getSaleReport('FACTURA', this.invoiceHeaders)
        },
        employeeSaleReport() {
            return this.getSaleReport(
                'VENTA EMPLEADO',
                this.employeeSaleHeaders
            )
        },
        creditNoteReport() {
            return this.getSaleReport('NOTA DE CREDITO', this.invoiceHeaders)
        },
        detailData() {
            if (!this.activeDocument) return null
            let obj = {}
            obj.isInvoice = !!this.activeDocument.sl_detail_sale_invoices
            obj.customer = obj.isInvoice
                ? this.activeDocument.sl_customer.alias_name
                : null
            obj.number = this.activeDocument.number
            obj.date = this.activeDocument.emission_date
            if (this.activeDocument.first_pos_sale) {
                obj.cashDesk = this.activeDocument.first_pos_sale.pos_cash_desk_id
                obj.cashier = this.activeDocument.first_pos_sale.g_cashier_user.hr_employee.name_case
                obj.seller = this.activeDocument.first_pos_sale.g_seller_user.hr_employee.name_case
            }
            return obj
        },
    },
    methods: {
        filterByType: type => item => item.tipo === type,
        groupById: (grouped, item) => {
            let index = grouped.findIndex(g => g.id === item.id)
            if (index !== -1) {
                grouped[index].details.push(item)
            } else {
                grouped.push({ id: item.id, details: [item] })
            }
            return grouped
        },
        saleMapper(item) {
            let obj = item.details[0]
            obj.payments = item.details.reduce((string, detail) => {
                string += `${detail.medio_de_pago}: $${detail.monto_medio_de_pago}, `
                return string
            }, '')
            obj.showPayments = item.details.reduce((string, detail) => {
                string += `${detail.medio_de_pago}: $${this.formatCurrency(
                    detail.monto_medio_de_pago
                )}, `
                return string
            }, '')
            obj.showPayments = obj.showPayments.slice(0, -2)
            let formatCurrency = amount =>
                `$${this.formatCurrency(parseInt(amount))}`
            let formatIfExists = amount =>
                amount ? formatCurrency(amount) : amount
            obj.showTotal = formatCurrency(obj.total)
            obj.showNeto = formatIfExists(obj.neto)
            obj.showIva = formatIfExists(obj.iva)
            return obj
        },
        getSaleReport(type, headers) {
            if (!this.reportData || !this.reportData.length)
                return { headers: [], items: [] }
            return {
                items: this.reportData
                    .filter(this.filterByType(type))
                    .reduce(this.groupById, [])
                    .map(this.saleMapper),
                headers: headers,
            }
        },
        ...mapActions('AuthModule', ['setOpenCashDesk']),
        ...mapActions('UniqueKeyModule', {
            authorize: 'authorize',
            setPermission: 'setPermission',
        }),
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            hideSnack: 'hideSnack',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),
        getSubmitData() {
            let obj = {}
            obj.real_cash_total = this.realCashTotal
            obj.real_debit_total = this.quadrature.debit.cashier_amount
            obj.real_credit_total = this.quadrature.credit.cashier_amount
            obj.real_credit_note_total =
                this.quadrature &&
                this.quadrature.credit_note &&
                (this.quadrature.credit_note.cashier_amount ||
                    this.quadrature.credit_note.cashier_amount === 0)
                    ? this.quadrature.credit_note.cashier_amount
                    : this.saleDetails &&
                      this.saleDetails.credit_note &&
                      this.saleDetails.credit_note.total
                    ? this.saleDetails.credit_note.total
                    : 0
            obj.real_check_to_day_total = this.saleDetails.check_to_day.total
            obj.real_check_to_date_total = this.saleDetails.check_to_date.total
            obj.real_customer_credit_total = this.saleDetails.customer_credit.total
            obj.real_electronic_transfer_total = this.saleDetails.electronic_transfer.total
            obj.real_bank_documents_total = this.saleDetails.bank_document.total
            Object.keys(this.billCounter).forEach(key => {
                let suffix =
                    this.billCounter[key].value >= 1000 ? '_bill' : '_coin'
                obj[key + suffix] = this.billCounter[key].quantity
            })
            obj.observation = this.observation
            obj.pos_cash_desk_id = this.cashDeskID
            obj.date = this.date
            obj.supervisor_user_code = this.uniqueKey
            obj.real_total = this.realCashTotal
            obj.cash_desk_total_diff = this.quadrature.cash.diff_amount
            return obj
        },
        async checkAuth() {
            let response = await this.authorize()
            if (
                response.status &&
                [200, 201, 'success'].includes(response.status)
            ) {
                this.authorized = true
                this.authUserId = response.user.id
                this.fetchMinorSales(this.date)
                    .then(r => {
                        this.minorSales = r.data
                        if (r.data.quantity && !r.data.ticket_was_generated)
                            this.minorSalesModal = true
                        else {
                            this.refresh().then(
                                () => (this.minorSalesReady = true)
                            )
                        }
                    })
                    .catch(e =>
                        this.showErrorSnack(
                            e.response && e.response.data
                                ? e.response.data.error
                                : e || 'Ha ocurrido un error'
                        )
                    )
            } else {
                this.showErrorSnack('Código Incorrecto')
                this.$router.push('/')
            }
        },
        showErrorSnack(text) {
            if (!this.authorized) return
            let payload = {
                typeMessage: 'error',
                message: {
                    title: 'Error',
                    body: text,
                },
                timeout: 6000,
                showProgress: false,
                showCloseBtn: true,
                closeBtnMessage: 'cerrar',
            }
            this.initSnackbar(payload)
        },
        fetchMinorSales(date) {
            const minorSalesRoute =
                process.env.VUE_APP_API_ROUTE +
                '/pos_minor_sale_ticket/total' +
                `?date=${date}`
            return new Promise((resolve, reject) =>
                axios
                    .get(minorSalesRoute)
                    .then(resolve)
                    .catch(reject)
            )
        },
        showSuccessSnack(text) {
            this.resetSnackbarState()
            let payload = {
                typeMessage: 'success',
                message: {
                    title: 'Éxito',
                    body: text,
                },
                timeout: 6000,
                showProgress: false,
                showCloseBtn: true,
                closeBtnMessage: 'cerrar',
            }
            this.initSnackbar(payload)
        },
        registerMinorSales() {
            this.showWaitingSnack('Registrando ventas menores...')
            const minorSalesRoute =
                process.env.VUE_APP_API_ROUTE + '/pos_minor_sale_ticket'
            axios
                .post(minorSalesRoute, {
                    cash_desk_token: this.cashDeskToken,
                    ticket_counter: this.minorSalesNumber,
                    date: this.date,
                })
                .then(() => {
                    this.showSuccessSnack(
                        'Ventas Menores Registradas Extiosamente'
                    )
                    this.minorSales.ticket_was_generated = true
                    this.minorSalesModal = false
                    this.refresh().then(() => (this.minorSalesReady = true))
                })
                .catch(e => {
                    this.showErrorSnack(
                        e.response && e.response.data
                            ? e.response.data.error
                            : e || 'Ha ocurrido un error'
                    )
                })
        },
        initData() {
            this.date = this.formatDate(new Date())
            this.fetchOpeningData()
        },
        showWaitingSnack(text) {
            if (!this.authorized) return
            this.resetSnackbarState()
            let payloadSnack = this.fillSnack(
                'info',
                text,
                'Espere un momento',
                true
            )
            this.initSnackbar(payloadSnack)
        },
        formatDate(date) {
            let month = '' + (date.getMonth() + 1)
            let day = '' + date.getDate()
            let year = date.getFullYear()
            if (month.length < 2) month = '0' + month
            if (day.length < 2) day = '0' + day
            return [year, month, day].join('-')
        },
        fetchOpeningData() {
            new PosDailyCash()
                .getAcitveDailyCash(this.cashDeskID)
                .then(r => {
                    this.openingData = r
                })
                .catch(e =>
                    this.showErrorSnack(
                        e.response && e.response.data
                            ? e.response.data.error
                            : e || 'Ha ocurrido un error'
                    )
                )
        },
        formatBillCounter() {
            let bills = cloneDeep(this.calcData.bills)
            let format = {
                twenty_thousand: { name: 'Billetes de $20.000', value: 20000 },
                ten_thousand: { name: 'Billetes de $10.000', value: 10000 },
                five_thousand: { name: 'Billetes de $5.000', value: 5000 },
                two_thousand: { name: 'Billetes de $2.000', value: 2000 },
                one_thousand: { name: 'Billetes de $1.000', value: 1000 },
                five_hundred: { name: 'Monedas de $500', value: 500 },
                one_hundred: { name: 'Monedas de $100', value: 100 },
                fifty: { name: 'Monedas de $50', value: 50 },
                ten: { name: 'Monedas de $10', value: 10 },
            }
            Object.keys(bills).forEach(k => {
                bills[k].name = format[k].name
                bills[k].value = format[k].value
                bills[k].backendName = k
            })
            this.billCounter = bills
        },
        formatQuadrature() {
            let quadrature = cloneDeep(this.calcData.quadrature)
            let format = {
                cash: {
                    name: 'Efectivo',
                    cashier_amount: this.realCashTotal,
                    readonly: true,
                },
                debit: { name: 'Débito' },
                credit: { name: 'Crédito' },
                credit_note: { name: 'Nota de Crédito' },
            }
            if (!this.newRendition) delete format.cash.cashier_amount
            Object.keys(quadrature).forEach(key => {
                quadrature[key] = Object.assign(quadrature[key], format[key])
                quadrature[key].diff_amount =
                    quadrature[key].cashier_amount -
                    quadrature[key].system_amount
            })
            this.quadrature = quadrature
        },
        updateBill() {
            let newBill = {}
            Object.keys(this.billCounter).forEach(key => {
                let obj = this.billCounter[key]
                if (obj.quantity) obj.amount = obj.quantity * obj.value
                else obj.amount = 0
                newBill[key] = obj
            })
            this.billCounter = { ...newBill }
        },
        updateQuadrature() {
            let quadrature = {}
            Object.keys(this.quadrature).forEach(key => {
                let obj = this.quadrature[key]
                if (!obj.cashier_amount) obj.cashier_amount = 0
                if (key === 'cash' && this.newRendition)
                    obj.cashier_amount = this.realCashTotal
                obj.diff_amount = obj.cashier_amount - obj.system_amount
                quadrature[key] = obj
            })
            this.quadrature = { ...quadrature }
        },
        sendRendition() {
            let route =
                process.env.VUE_APP_API_ROUTE + '/pos_daily_sales_report'
            return new Promise((resolve, reject) =>
                axios
                    .post(route, this.getSubmitData())
                    .then(resolve)
                    .catch(reject)
            )
        },
        fetchCalcRendition() {
            let route =
                process.env.VUE_APP_API_ROUTE +
                '/pos_daily_sales_report/calculate/get'
            let query =
                `?pos_cash_desk_id=${this.cashDeskID}&date=${this.date}` +
                '&iclude=pos_daily_sales_report_detail_retirement.pos_cash_movement'
            return new Promise((resolve, reject) =>
                axios
                    .get(route + query)
                    .then(r => {
                        if (r && r.data && r.data.pos_daily_sales_report)
                            return resolve(r.data.pos_daily_sales_report)
                        else reject('No se encontraron resultados')
                    })
                    .catch(reject)
            )
        },
        fetchMovementDetails(date = this.date, id = this.cashDeskID) {
            return new PosCashMovement()
                .where('created_at', date)
                .where('pos_cash_desk_id', id)
                .where('exclude_ingress_receivable', 1)
                .include(
                    'pos_cash_movement_ingress_type',
                    'pos_cash_movement_egress_type'
                )
                .limit(-1)
                .get()
        },
        fetchData(cashDesk, date) {
            return new Promise((resolve, reject) => {
                Promise.all([
                    this.fetchRendition(),
                    this.fetchMinorSales(date),
                    getIntegrationTicketNumber(),
                ])
                    .then(resolve)
                    .catch(reject)
            })
        },
        async fetchExistingData(cashDesk, date) {
            let route =
                process.env.VUE_APP_API_ROUTE + '/pos_daily_sales_report/date'
            try {
                let response = await axios.post(route, {
                    pos_cash_desk_id: cashDesk,
                    date: date,
                })
                this.newRendition = false
                return response
            } catch (e) {
                return e.response
            }
        },
        fetchRendition() {
            this.newRendition = true
            return new Promise((resolve, reject) => {
                this.fetchCalcRendition()
                    .then(resolve)
                    .catch(e => {
                        if (
                            e &&
                            e.response &&
                            e.response.data &&
                            e.response.data.error ===
                                'Ya existe una rendición de ventas para la caja y fecha especificadas'
                        )
                            this.fetchExistingData(this.cashDeskID, this.date)
                                .then(r =>
                                    resolve(r.data.pos_daily_sales_report)
                                )
                                .catch(reject)
                        else reject(e)
                    })
            })
        },
        handleSubmitButton() {
            if (!this.newRendition) return this.downloadPdf()
            this.setMessageConfirmSnack('Enviar Rendición')
            let payload = this.fillSnack(
                'warning',
                'Confirme rendición de caja',
                'Una vez enviada la rendición, no podrá ser modificada'
            )
            this.minorSalesModal = false
            this.initSnackbar(payload)
        },
        submit() {
            const handleError = e =>
                this.showErrorSnack(
                    e.response && e.response.data ? e.response.data.error : e
                )
            return new Promise((resolve, reject) =>
                this.sendRendition()
                    .then(response => {
                        this.downloadPdf()
                        this.showSuccessSnack('Rendición guardada exitosamente')
                        this.setOpenCashDesk(false)
                        setTimeout(() => this.$router.push('/movement'), 1000)
                        resolve(response)
                    })
                    .catch(e => {
                        handleError(e)
                        reject(e)
                    })
            )
        },
        async downloadPdf() {
            const route =
                process.env.VUE_APP_API_ROUTE +
                '/pos_daily_sales_report/date_pdf'
            let query = `?pos_cash_desk_id=${this.cashDeskID}&date=${this.date}`
            let response = await axios.get(route + query, {
                responseType: 'blob',
            })
            const fileName = `rendicion_caja_${this.cashDeskID}_${this.date}.pdf`
            const linkSource = URL.createObjectURL(response.data)
            const downloadLink = document.createElement('a')
            downloadLink.href = linkSource
            downloadLink.download = fileName
            downloadLink.click()
        },
        fetchReport() {
            let route =
                process.env.VUE_APP_API_ROUTE + `/pos_sales_summary_report`
            return new Promise((resolve, reject) => {
                axios
                    .post(route, {
                        start_date: this.date,
                        end_date: this.date,
                        branch_office_id: this.branchOfficeID,
                        pos_cash_desk_id: this.cashDeskID,
                    })
                    .then(r => resolve(r.data))
                    .catch(reject)
            })
        },
        async refresh(date = this.date) {
            this.resetSnackbarState()
            this.showWaitingSnack(`Cargando datos del ${date}`)
            let fullData = null
            let response = null
            try {
                fullData = await this.fetchData(this.cashDeskID, date)
                response = fullData[0]
                this.minorSales = fullData[1].data
                this.minorSalesNumber = fullData[2]
                this.calcData = response
                if (response.general && response.general.observation)
                    this.observation = response.general.observation
            } catch (e) {
                if (!e.response) return
                response = e.response
                let ms = await this.fetchMinorSales(date)
                this.minorSales = ms.data
            }
            if (
                this.authorized &&
                this.minorSales &&
                this.minorSales.quantity &&
                !this.minorSales.ticket_was_generated
            )
                this.minorSalesModal = true
            this.fetchReport().then(r => (this.reportData = r))
            this.formatQuadrature()
            this.formatBillCounter()
            this.resetSnackbarState()
            this.loadingMovements = true
            let res = await this.fetchMovementDetails()
            this.movementDetails = res.data.map(d => {
                if (d.pos_cash_movement_ingress_type_id) {
                    d.type = 'Ingreso'
                    d.movementType = d.pos_cash_movement_ingress_type.type
                }
                if (d.pos_cash_movement_egress_type_id) {
                    d.type = 'Egreso'
                    d.movementType = d.pos_cash_movement_egress_type.type
                }
                d.date = d.created_at.split(' ')[0]
                d.time = d.created_at.split(' ')[1]
                return d
            })
            this.getAllCreditNotes()
            this.getPayments()
            this.loadingMovements = false
        },
        showTicketReport() {
            this.activeReport = 0
            this.showReportModal = true
        },
        showInvoiceReport() {
            this.activeReport = 1
            this.showReportModal = true
        },
        showCreditNoteReport() {
            this.activeReport = 2
            this.showReportModal = true
        },
        showAllCreditNoteReport() {
            this.activeReport = 3
            this.showReportModal = true
        },
        showPaymentReport() {
            this.activeReport = 4
            this.showReportModal = true
        },
        fetchDetail(item) {
            let commonIncludes = [
                'first_pos_sale.pos_cash_desk.g_branch_office',
                'first_pos_sale.g_seller_user.hr_employee',
                'first_pos_sale.g_cashier_user.hr_employee',
            ]
            let mdl = null
            if (item.tipo === 'BOLETA')
                mdl = new SlSaleTicket()
                    .include(
                        'sl_detail_sale_tickets.wh_product',
                        ...commonIncludes
                    )
                    .custom(
                        process.env.VUE_APP_API_ROUTE +
                            `/sl_sale_ticket/number/${item.folio}`
                    )
                    .get()
            if (item.tipo === 'FACTURA')
                mdl = new SlSaleInvoice()
                    .include(
                        'sl_detail_sale_invoices.wh_product',
                        'sl_customer',
                        ...commonIncludes
                    )
                    .custom(
                        process.env.VUE_APP_API_ROUTE +
                            `/sl_sale_invoice/number/${item.folio}`
                    )
                    .get()
            if (!mdl) return
            mdl.then(r => {
                r[0].detail = r[0].sl_detail_sale_tickets
                    ? r[0].sl_detail_sale_tickets
                    : r[0].sl_detail_sale_invoices
                this.activeDocument = r[0]
                this.showDocumentModal = true
            }).catch(console.log)
        },
        getItemPrice(item) {
            if (item.price) return item.price
            return Math.round(item.net_price * 1.19)
        },
        getItemDiscounts(item) {
            if (parseInt(item.discount_or_charge_percentage))
                return parseInt(item.discount_or_charge_percentage) + ' %'
            if (parseInt(item.discount_or_charge_value))
                return '$ ' + parseInt(item.discount_or_charge_value)
            return '-'
        },
        getItemTotal(item) {
            let tot = this.getItemPrice(item) * item.quantity
            if (parseInt(item.discount_or_charge_percentage))
                return (
                    tot *
                    ((100 - parseInt(item.discount_or_charge_percentage)) / 100)
                )
            if (parseInt(item.discount_or_charge_value))
                return tot + parseInt(item.discount_or_charge_value)
            return tot
        },
        getAllCreditNotes() {
            SlSaleCreditNote.include([
                'sl_customer',
                'sl_customer_account_movement',
                'sl_customer_branch_offices.g_commune',
                'sl_service_order.g_creator.hr_employee',
                'sl_service_order.g_supervisor_user.hr_employee',
                'sl_service_order.sl_sale_ticket_affected',
                'sl_service_order.sl_sale_invoice_affected',
            ])
                .where('emission_date', this.date)
                .limit(-1)
                .get()
                .then(this.setAllCreditNotes)
        },
        setAllCreditNotes(res) {
            const frmCurrency = this.formatCurrency
            this.allCreditNoteReport = {
                headers: this.allCreditNotesHeaders,
                items: res.data.map(item => ({
                    folio: item.number,
                    cliente: item.sl_customer.alias_name.trim(),
                    supervisor:
                        item.sl_service_order.g_supervisor_user.hr_employee
                            .name_case,
                    cajero:
                        item.sl_service_order.g_creator.hr_employee.name_case,
                    total: `$ ${frmCurrency(item.total)}`,
                })),
            }
        },
        getPayments() {
            PosCustomerReceivablePayment.include(
                PosCustomerReceivablePayment.includes
            )
                .where('date', this.date)
                .limit(-1)
                .get()
                .then(this.setPayments)
        },
        setPayments(res) {
            const frmCurrency = this.formatCurrency
            this.payments = {
                headers: [
                    {
                        text: 'Folio',
                        value: 'folio',
                    },
                    {
                        text: 'Rut',
                        value: 'rut',
                    },
                    {
                        text: 'Cliente',
                        value: 'alias_name',
                    },
                    {
                        text: 'Caja',
                        value: 'caja',
                    },
                    {
                        text: 'Supervisor',
                        value: 'supervisor',
                    },
                    {
                        text: 'Total',
                        value: 'total',
                    },
                ],
                items: res.data.map(item => ({
                    folio: item.id,
                    rut: item.sl_customer.rut,
                    alias_name: item.sl_customer.alias_name,
                    caja: `${item.pos_cash_desk.number} - ${item.pos_cash_desk.name}`,
                    supervisor: item.g_user.hr_employee.name_case,
                    //cliente: item.sl_customer.alias_name.trim(),
                    //supervisor: item.sl_service_order.g_supervisor_user.hr_employee.name_case,
                    //cajero: item.sl_service_order.g_creator.hr_employee.name_case,
                    total: `$ ${frmCurrency(item.total)}`,
                })),
            }
        },
    },
    watch: {
        async responseConfirm(val) {
            if (val == 'Enviar Rendición') {
                this.resetSnackbarState()
                this.submit()
            }
        },
        async date(val) {
            await this.refresh(val)
        },
        realCashTotal() {
            this.updateQuadrature()
        },
        showReportModal(v) {
            if (!v) this.reportFilter = ''
        },
    },
    created() {
        this.initData()
    },
    mounted() {
        this.setPermission(
            this.mixAuthCodePermissions.CREATE_AUTH_POS_DAILY_SALE_REPORT
        )
        this.getAllCreditNotes()
        document.getElementById('supervisor-modal-button').click()
    },
}
